import { createBrowserRouter } from 'react-router';
import { AppLayout } from '@/layouts/AppLayout';
import { AuthGate } from '@/components/AuthGate';
import { HomeRoute } from '@/routes/home';
import { ApprovalsRoute } from '@/routes/approvals';
import { LoginRoute } from '@/routes/login';
import { NoticesRoute } from '@/routes/notices';
import { MyRequestsRoute } from '@/routes/my-requests';
import { MessengerRoute } from '@/routes/messenger';
import { ProfileRoute } from '@/routes/profile';
import { AttendanceRoute } from '@/routes/attendance';
import { ReportsRoute } from '@/routes/reports';
import { FaInventoryRoute } from '@/routes/fa-inventory';
import { PlaceholderRoute } from '@/routes/placeholder';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <AuthGate guestOnly>
        <LoginRoute />
      </AuthGate>
    ),
  },
  {
    path: '/',
    element: (
      <AuthGate>
        <AppLayout />
      </AuthGate>
    ),
    children: [
      { index: true, Component: HomeRoute },
      { path: 'approvals', Component: ApprovalsRoute },
      { path: 'notices', Component: NoticesRoute },
      { path: 'messages', Component: MessengerRoute },
      { path: 'reports', Component: ReportsRoute },
      { path: 'profile', Component: ProfileRoute },
      { path: 'profile/account',  element: <PlaceholderRoute titleKey="profile.row_account"  path="/profile/account"  icon="person" /> },
      { path: 'profile/language', element: <PlaceholderRoute titleKey="profile.row_language" path="/profile/language" icon="translate" /> },
      { path: 'profile/security', element: <PlaceholderRoute titleKey="profile.row_password" path="/profile/security" icon="lock" /> },
      { path: 'profile/devices',  element: <PlaceholderRoute titleKey="profile.row_devices"  path="/profile/devices"  icon="devices" /> },
      { path: 'requests', Component: MyRequestsRoute },
      { path: 'attendance', Component: AttendanceRoute },
      { path: 'fa-inventory', Component: FaInventoryRoute },
    ],
  },
]);
